import {firebaseAction} from 'vuexfire'
import firebase from 'firebase/app';
import {EventBus} from "../util/event-bus";

export default {
    namespaced: true,
    state: {
        list: [],

    },
    getters: {},
    mutations: {},
    actions: {

        //BINDINGS

        setList: firebaseAction(({bindFirebaseRef}, ref) => {
            return new Promise(resolve => {
                bindFirebaseRef('list', ref, {
                    readyCallback() {
                        resolve();
                    }
                })
            })
        }),
        createPdf: function (context, form) {
            return new Promise((resolve) => {

                let payload = form.pdf;
                let id = firebase.database().ref().push().key;

                firebase.database().ref('pdfs').child(id).set(payload).then(() => {
                    resolve(id)
                });
            })
        },
        updatePdf: function (context, data) {
            data = data.data;//???
            return new Promise(resolve => {
                firebase.database().ref('pdfs/' + data.id).update({
                    name: data.name,
                    link: data.link
                }).then(() => resolve());
            });
        },
        deletePdf: function ( context, { id}) {
            return firebase.database().ref('/pdfs').child(id).remove();
        },
    }

}
